<!--
 Created by Xuz on 2020/03/04.
 xuz[at]live[dot]cn
 管理员修改用户意见
-->
<template>
  <a-modal title="编辑意见" :visible="visible" :maskClosable="false" :width="960" destroyOnClose
           @ok="onSaveComment"
           @cancel="() => this.visible = false"
           :confirmLoading="loading">
    <a-alert style="margin: -24px -24px 20px -24px" message="修改流程的意见时间会造成流程意见列表先后顺序出现错乱，可通过修改其他意见的时间来调整。" banner type="warning"/>
    <a-form :form="form">
      <a-form-item label='原签用户' v-bind="formItemLayout">
        <span>{{result.userName}}</span>
      </a-form-item>
      <a-form-item label='意见类型' v-bind="formItemLayout">
        <a-select placeholder="意见类型" v-decorator="['commentTypeId', {initialValue:result.commentTypeId}]">
          <a-select-option v-for="(item, idx) in opinions" :key='idx' :value="item.opinionId">{{item.opinionName}}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label='意见时间' v-bind="formItemLayout">
        <a-date-picker placeholder='意见时间' showTime
                       v-decorator="['updatedAt', {initialValue:result.updatedAt, rules: [{ required: true, message: '请选择意见时间' }]}]"/>
      </a-form-item>
      <a-form-item label='意见内容' v-bind="formItemLayout">
        <a-textarea placeholder="请填写意见" :rows="4"
                    v-decorator="['content', {initialValue:result.content,rules: [{ required: true, message: '请填写意见' }]}]"/>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import qs from 'qs'
import moment from 'moment'

export default {
  name: 'WorkflowCommentEdit',
  components: {
  },
  data () {
    return {
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: {
          md: { span: 5 }
        },
        wrapperCol: {
          md: { span: 12 }
        }
      },
      loading: false,
      visible: false,
      result: {
        updatedAt: null
      },
      opinions: []
    }
  },
  methods: {
    preCommentEdit (commentId) {
      this.visible = true
      this.loading = true
      this.$http.get('/api/1/workflow/comment/get_comment.json?id=' + commentId).then(resp => {
        this.loading = false
        let result = resp.result
        this.opinions = result.extras.opinions

        result.updatedAt = moment(result.updatedAt)
        this.result = result
      })
    },
    onSaveComment () {
      let that = this
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        let params = this.form.getFieldsValue()
        if (params.updatedAt) {
          params.updatedAt = params.updatedAt.format('YYYY-MM-DD HH:mm')
        }

        params.id = this.result.id
        params.procInsId = this.result.procInsId

        this.loading = true
        this.$http.post('/api/1/workflow/comment/edit_comment.json', qs.stringify(params)).then(function (resp) {
          that.loading = false
          that.visible = false
          that.$emit('success')
        })
      })
    }
  }
}
</script>

<style scoped>
</style>
